import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";
import apiClient from "api-client";

export const useUploadDocumentMutation = getWrappedUseMutation(apiClient.ForumGroupDocuments.post);

export const useDeleteDocumentMutation = getWrappedUseMutation(apiClient.ForumGroupDocuments.delete);
